import client from "../../../../client";
import type { RequestConfig, ResponseErrorConfig } from "../../../../client";
import type {
  GetApiPaymentFederalAchQueryResponse,
  GetApiPaymentFederalAch401,
  GetApiPaymentFederalAch403,
} from "../../../types/GetApiPaymentFederalAch";

export function getGetApiPaymentFederalAchUrl() {
  return `/api/Payment/federal-ach` as const;
}

/**
 * {@link /api/Payment/federal-ach}
 */
export async function getApiPaymentFederalAch(
  config: Partial<RequestConfig> & { client?: typeof client } = {}
) {
  const { client: request = client, ...requestConfig } = config;

  const res = await request<
    GetApiPaymentFederalAchQueryResponse,
    ResponseErrorConfig<
      GetApiPaymentFederalAch401 | GetApiPaymentFederalAch403
    >,
    unknown
  >({
    method: "GET",
    url: getGetApiPaymentFederalAchUrl().toString(),
    ...requestConfig,
  });
  return res;
}
